import React from 'react';
import { ShieldIcon, BadgeCheckIcon, TruckIcon, RefreshCcwIcon, UserIcon } from 'lucide-react';
export const AboutPage = () => {
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-104">
      <div className="container mx-auto px-4 py-8" data-id="element-105">
        {/* Hero Section */}
        <div className="bg-white rounded-xl shadow-sm overflow-hidden mb-12" data-id="element-106">
          <div className="bg-gradient-to-r from-green-50 to-amber-50 p-8 md:p-12" data-id="element-107">
            <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-108">
              About TechGold
            </h1>
            <p className="text-lg text-gray-700 max-w-3xl" data-id="element-109">
              Your trusted marketplace for high-quality used electronics and
              investment-grade precious metals. We combine technical expertise
              with financial acumen to offer products you can trust.
            </p>
          </div>
        </div>
        {/* Our Story */}
        <div className="mb-16" data-id="element-110">
          <h2 className="text-2xl font-bold mb-8 text-center" data-id="element-111">Our Story</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-112">
            <div data-id="element-113">
              <p className="text-gray-700 mb-4" data-id="element-114">
                Founded in 2018, TechGold began with a simple mission: to create
                a marketplace where customers could purchase both premium
                refurbished electronics and investment-grade precious metals
                with complete confidence.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-115">
                Our founder, a former tech industry executive with a passion for
                precious metals investing, recognized that both markets suffered
                from the same problems: lack of transparency, inconsistent
                quality, and poor customer service.
              </p>
              <p className="text-gray-700" data-id="element-116">
                Today, TechGold has grown into a trusted destination for savvy
                consumers and investors who appreciate our rigorous quality
                standards, competitive pricing, and exceptional customer
                experience.
              </p>
            </div>
            <div className="bg-gray-100 rounded-xl p-8" data-id="element-117">
              <div className="space-y-6" data-id="element-118">
                <div className="flex" data-id="element-119">
                  <div className="flex-shrink-0" data-id="element-120">
                    <div className="bg-green-100 rounded-full h-12 w-12 flex items-center justify-center" data-id="element-121">
                      <BadgeCheckIcon size={24} className="text-green-500" data-id="element-122" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-123">
                    <h3 className="text-lg font-medium" data-id="element-124">
                      Certified Refurbishment
                    </h3>
                    <p className="text-gray-600" data-id="element-125">
                      Every electronic device undergoes a rigorous 27-point
                      inspection process.
                    </p>
                  </div>
                </div>
                <div className="flex" data-id="element-126">
                  <div className="flex-shrink-0" data-id="element-127">
                    <div className="bg-amber-100 rounded-full h-12 w-12 flex items-center justify-center" data-id="element-128">
                      <ShieldIcon size={24} className="text-amber-500" data-id="element-129" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-130">
                    <h3 className="text-lg font-medium" data-id="element-131">
                      Authenticated Metals
                    </h3>
                    <p className="text-gray-600" data-id="element-132">
                      All precious metals are verified for authenticity and
                      purity.
                    </p>
                  </div>
                </div>
                <div className="flex" data-id="element-133">
                  <div className="flex-shrink-0" data-id="element-134">
                    <div className="bg-blue-100 rounded-full h-12 w-12 flex items-center justify-center" data-id="element-135">
                      <UserIcon size={24} className="text-blue-500" data-id="element-136" />
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-137">
                    <h3 className="text-lg font-medium" data-id="element-138">Expert Team</h3>
                    <p className="text-gray-600" data-id="element-139">
                      Our staff includes certified technicians and precious
                      metals specialists.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Our Values */}
        <div className="mb-16" data-id="element-140">
          <h2 className="text-2xl font-bold mb-8 text-center" data-id="element-141">Our Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-142">
            <div className="bg-white rounded-xl shadow-sm p-6 text-center" data-id="element-143">
              <div className="bg-green-50 rounded-full h-16 w-16 flex items-center justify-center mx-auto mb-4" data-id="element-144">
                <ShieldIcon size={32} className="text-green-500" data-id="element-145" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-146">
                Trust & Transparency
              </h3>
              <p className="text-gray-600" data-id="element-147">
                We provide detailed information about every product's condition,
                history, and specifications. No surprises, just honest
                descriptions.
              </p>
            </div>
            <div className="bg-white rounded-xl shadow-sm p-6 text-center" data-id="element-148">
              <div className="bg-green-50 rounded-full h-16 w-16 flex items-center justify-center mx-auto mb-4" data-id="element-149">
                <BadgeCheckIcon size={32} className="text-green-500" data-id="element-150" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-151">Quality Assurance</h3>
              <p className="text-gray-600" data-id="element-152">
                We never compromise on quality. Our rigorous testing and
                authentication processes ensure you receive only the best
                products.
              </p>
            </div>
            <div className="bg-white rounded-xl shadow-sm p-6 text-center" data-id="element-153">
              <div className="bg-green-50 rounded-full h-16 w-16 flex items-center justify-center mx-auto mb-4" data-id="element-154">
                <RefreshCcwIcon size={32} className="text-green-500" data-id="element-155" />
              </div>
              <h3 className="text-xl font-semibold mb-3" data-id="element-156">Sustainability</h3>
              <p className="text-gray-600" data-id="element-157">
                By giving technology a second life, we reduce electronic waste.
                Our packaging is eco-friendly and minimizes environmental
                impact.
              </p>
            </div>
          </div>
        </div>
        {/* Customer Guarantees */}
        <div className="mb-16" data-id="element-158">
          <h2 className="text-2xl font-bold mb-8 text-center" data-id="element-159">
            Our Guarantees
          </h2>
          <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-160">
            <div className="grid grid-cols-1 md:grid-cols-3" data-id="element-161">
              <div className="p-6 border-b md:border-b-0 md:border-r border-gray-200" data-id="element-162">
                <div className="flex items-center mb-4" data-id="element-163">
                  <ShieldIcon size={24} className="text-green-500 mr-3" data-id="element-164" />
                  <h3 className="text-lg font-semibold" data-id="element-165">30-Day Warranty</h3>
                </div>
                <p className="text-gray-600" data-id="element-166">
                  All electronic products come with a 30-day warranty. If
                  anything doesn't work as expected, we'll make it right.
                </p>
              </div>
              <div className="p-6 border-b md:border-b-0 md:border-r border-gray-200" data-id="element-167">
                <div className="flex items-center mb-4" data-id="element-168">
                  <TruckIcon size={24} className="text-green-500 mr-3" data-id="element-169" />
                  <h3 className="text-lg font-semibold" data-id="element-170">Free Shipping</h3>
                </div>
                <p className="text-gray-600" data-id="element-171">
                  Enjoy free shipping on all orders over $500. Your items will
                  be carefully packaged and fully insured.
                </p>
              </div>
              <div className="p-6" data-id="element-172">
                <div className="flex items-center mb-4" data-id="element-173">
                  <RefreshCcwIcon size={24} className="text-green-500 mr-3" data-id="element-174" />
                  <h3 className="text-lg font-semibold" data-id="element-175">Easy Returns</h3>
                </div>
                <p className="text-gray-600" data-id="element-176">
                  Not satisfied? Return your purchase within 30 days for a full
                  refund. We make the process simple and hassle-free.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Call to Action */}
        <div className="bg-gradient-to-r from-green-500 to-green-600 rounded-xl shadow-sm overflow-hidden text-white text-center p-8 md:p-12" data-id="element-177">
          <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-178">
            Ready to experience the TechGold difference?
          </h2>
          <p className="text-lg mb-6 max-w-2xl mx-auto" data-id="element-179">
            Browse our curated selection of premium refurbished electronics and
            investment-grade precious metals today.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-180">
            <button className="bg-white text-green-600 py-3 px-6 rounded-lg hover:bg-gray-100 transition-colors shadow-sm" data-id="element-181">
              Shop Electronics
            </button>
            <button className="bg-amber-500 text-white py-3 px-6 rounded-lg hover:bg-amber-600 transition-colors shadow-sm" data-id="element-182">
              Browse Metals
            </button>
          </div>
        </div>
      </div>
    </div>;
};